export function getProfileImageRoute(username: string): string {
    // Gets the profile image for the specified user, and tags it with the current timestamp to force a "refresh" if needed.
    // todo: Ideally this would just point to https://images.pondertcg.com but first we would need to do a invalidation in the event of an update.
    return `https://s3.us-east-1.amazonaws.com/images.pondertcg.com/user/avatar/${username!}?t=${(new Date()).getTime()}`;
}